import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { downloadRegisterExcel } from "routes/asset-register/lib/download-register-excel"
import { useRegisterProcessingGuard } from "routes/asset-register/plugins/register-actions/use-register-processing-guard"

export function ExportRegisterMenuItem() {
    const { register } = useBoundContext()
    const { isBlocked, showBlockedAlert } = useRegisterProcessingGuard()

    return (
        <ContextMenuItem
            icon="mdi:download"
            label="Export"
            onClick={exportRegister}
            data-cy="register-row-menu-export"
        />
    )

    async function exportRegister() {
        if (isBlocked) {
            showBlockedAlert()
            return
        }
        await downloadRegisterExcel({ registerId: register.id, registerName: register.name })
    }
}
